"use client";

import { datadogRum } from "@datadog/browser-rum";
import packageJson from "../../package.json";

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
const env = process.env.NEXT_PUBLIC_DATADOG_ENV || "dev";
const team = process.env.NEXT_PUBLIC_DATADOG_TEAM;
const awsAccount = process.env.NEXT_PUBLIC_DATADOG_AWS_ACCOUNT;
const kubeNamespace = process.env.NEXT_PUBLIC_DATADOG_KUBE_NAMESPACE;

if (applicationId && clientToken && team && awsAccount && kubeNamespace) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: "ap1.datadoghq.com",
    service: "exaauth-portal",
    env,
    version: packageJson.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  datadogRum.setGlobalContextProperty("team", team);
  datadogRum.setGlobalContextProperty("aws_account", awsAccount);
  datadogRum.setGlobalContextProperty("kube_namespace", kubeNamespace);
}

export default function DatadogInit() {
  return null;
}
